import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './assets/css/base.scss'
import toast from './components/toast'

const RESIZE_OBSERVER_LOOP_ERROR = 'ResizeObserver loop completed with undelivered notifications'

function isResizeObserverLoopError(payload) {
  if (!payload) {
    return false
  }
  if (typeof payload === 'string') {
    return payload.includes(RESIZE_OBSERVER_LOOP_ERROR)
  }
  if (payload.message && typeof payload.message === 'string') {
    return payload.message.includes(RESIZE_OBSERVER_LOOP_ERROR)
  }
  return false
}

window.addEventListener('error', (event) => {
  const message = event?.message || event?.error?.message
  if (!isResizeObserverLoopError(message)) {
    return
  }
  event.stopImmediatePropagation()
  event.preventDefault()
}, true)

window.addEventListener('unhandledrejection', (event) => {
  if (!isResizeObserverLoopError(event?.reason)) {
    return
  }
  event.preventDefault()
}, true)

const app = createApp(App);
app.use(router);
app.use(ElementPlus);
app.use(toast);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app');
 